import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  styled,
  Typography,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import { useEffect } from "react";
import { Link } from "react-router-dom";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import Swal from "sweetalert2";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

const CustomSelect = styled(Select)({
  color: "white", // Optional: to change text color
  "& .MuiSelect-icon": {
    color: "white", // Changes the dropdown icon color to white
  },
});

export default function FaqGenerator({ chatbotTitle, link }) {
  const [pdfFile, setpdfFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [generateLoad, setGenerateload] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [error, setError] = useState("");
  const [deleteError, setdeleteError] = useState("");
  const [selectedValue, setSelectedValue] = useState(5);
  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (transcript && transcript.length > 0) {
      // Ensure transcript is not undefined
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplayText((prev) => prev + transcript[index]);
        index++;
        if (index === transcript.length) {
          clearInterval(intevalId);
        }
      }, 10);
    } else {
      setDisplayText(""); // Clear the display text if transcript is undefined or empty
    }
    setTranScript("");
  }, [transcript]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setpdfFile(file);
  };
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleCompare = async (number_of_FAQ) => {
    try {
      setGenerateload(true);
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        number_of_FAQ: number_of_FAQ,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch request
      const requesttrain = await fetch(
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/faq-generator",
        trainoption,
      );

      // Check if the response is successful
      // if (requesttrain.ok) {
      //   setError("Comparison completed.");
      // }

      // Parse the JSON data from the response
      const response = await requesttrain.json();
      setTranScript(response.messsage);
      console.log("Response data:", response);
    } catch (error) {
      // Handle any errors
      console.error("There was an error with the fetch request:", error);
    } finally {
      setGenerateload(false);
    }
  };

  const getUsername = () =>
    localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

  const handleTrain = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if (pdfFile) {
      setTrainload(true);
      setdeleteError("");
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var data = JSON.stringify({
        docpath: username,
        docname: pdfFile.name,
      });

      var xhr = new XMLHttpRequest();
      // xhr.withCredentials = true;
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          if (this.responseText.toString().includes("errorMessage")) {
            Swal.fire("Please upload data file.");
            setTrainload(false);
          } else {
            console.log(this.responseText);
            setError("Training completed!");
            setTrainload(false);
          }
        }
      });

      xhr.open(
        "POST",
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/custom-chatbot",
      );
      // xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(data);
    } else {
      Swal.fire("Please upload data file.");
    }
  };
  const handleUpload = async () => {
    setcsvload(true);
    if (!pdfFile) return;

    try {
      const username = getUsername();
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(pdfFile, username);

      console.log("File uploaded successfully");
      setcsvload(false);
      setError("File uploaded successfully.");
      setUploadStatus(true);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setcsvload(false);
    }
  };
  return (
    <div>
      <div>
        <img
          alt="overlay-img"
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          alt="main-background-img"
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {chatbotTitle}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div className="emailsum-container" style={{ alignContent: "start" }}>
          <div className="input-form-chatbot" style={{ margin: "0 2rem" }}>
            <h3>
              <strong>Training Window</strong>
            </h3>
            <hr style={{ background: "white" }}></hr>
            <div className="field">
              <p>Select PDF file to train:</p>
              <div>
                <input
                  accept=".pdf"
                  id="csv-upload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                <label htmlFor="csv-upload">
                  <Button variant="contained" component="span">
                    Select PDF
                  </Button>
                </label>
                <Typography variant="body1">
                  {pdfFile && `Selected file: ${pdfFile.name}`}
                </Typography>

                <br />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!pdfFile}
                    onClick={handleUpload}
                    style={{
                      margin: "0 1rem 0 0",
                      backgroundColor: !pdfFile ? "#ccc" : "", // Light gray background when disabled
                      color: !pdfFile ? "#000" : "", // Darker text to make it more visible
                      opacity: !pdfFile ? 1 : 1, // Ensure the button is fully visible
                      pointerEvents: !pdfFile ? "none" : "auto", // Disable interaction when disabled
                    }}
                    startIcon={
                      csvload && <CircularProgress color="white" size={20} />
                    }
                  >
                    Upload
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    style={{ color: "white" }}
                    onClick={handleTrain}
                    startIcon={
                      trainload && <CircularProgress color="white" size={20} />
                    }
                  >
                    Train
                  </Button>
                  {uploadStatus && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                        top: "1rem",
                      }}
                      size={25}
                    />
                  )}
                </div>
              </div>
              <br />
              {error}
            </div>
            <FormControl>
              <p>Select number of faq:</p>
              <CustomSelect
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
                SelectDisplayProps={{
                  style: {
                    color: "white",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      backgroundColor: "#222",
                      color: "white",
                    },
                  },
                }}
              >
                <MenuItem value={5} style={{ color: "white" }}>
                  5
                </MenuItem>
                <MenuItem value={10} style={{ color: "white" }}>
                  10
                </MenuItem>
                <MenuItem value={15} style={{ color: "white" }}>
                  15
                </MenuItem>
              </CustomSelect>
            </FormControl>
            <br />
            <br />
            <Button
              variant="contained"
              color="primary"
              component="span"
              style={{ color: "white" }}
              onClick={() => {
                handleCompare(selectedValue);
              }}
              startIcon={
                generateLoad && <CircularProgress color="white" size={20} />
              }
            >
              Generate Answer
            </Button>
            <br />
            <br />
            {deleteError}
          </div>
          <div className="result-chatbot">
            {/* <h4>Chatbot</h4> */}
            <h3>
              <strong>Output Window</strong>
            </h3>
            <hr style={{ background: "white" }}></hr>
            {displayText.length > 0 ? (
              <pre
                style={{
                  color: "white",
                  fontFamily: "sans-serif",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                }}
              >
                {displayText}
              </pre>
            ) : (
              "Response will be displayed here"
            )}
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
